// import Button from "@/Components/Button";
import { toWebp } from "@/utils/common";
import Image from "next/image";
import Link from "next/link";
// import { useRouter } from "next/navigation";
// import { useState } from "react";

interface GameChangerProps {
  data?: any;
  isMobile?: boolean;
}

const Industry: React.FC<GameChangerProps> = ({ data }) => {
  //const router = useRouter();
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  return (
    <>
      <section className="relative z-[1] overflow-hidden pb-[56px] pt-[56px] lg:pb-[80px] xl:pb-[100px] lg:pt-[80px] xl:pt-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
        <div className="container">
          <div className="heading mb-[40px]">
            <h2 className="lg:text-[48px] xl:text-[65px] xm:text-[32px] text-[26px] text-center xl:leading-[83.3px] lg:leading-[62.4px] xm:leading-[41.6px] leading-[35px] font-[700] text-[#040405]">
              {data?.title ?? ""}
            </h2>
            <p className="text-subtitle-2 font-regular text-secondary-text mt-3 max-w-[980px] mx-auto text-center">
              {data?.short_title ?? ""}
            </p>
          </div>

          <div className="flex justify-center flex-row sm:gap-3 w-full max-w-full flex-wrap  ml-0 mx-auto relative z-10">
            {data?.technologies?.map((item: any, index: number) => (
              <Link
                key={index}
                href={item?.button?.href ?? ""}
                className="flex items-center mr-3 mb-3 lg:mb-0"
              >
                <div
                  className={`h-[48px] w-[48px] flex items-center justify-center border border-r-0 ${index % 2 === 0 ? "bg-blue-50 border-blue-100" : "bg-green-50 border-green-100"}`}
                >
                  {item?.image?.data?.attributes?.url && (
                    <Image
                      alt="Ownership"
                      loading="lazy"
                      width="24"
                      height="24"
                      quality={100}
                      decoding="async"
                      src={toWebp(
                        `${baseUrl}${item?.image?.data?.attributes?.url}`,
                      )}
                      style={{ color: "transparent" }}
                    />
                  )}
                </div>
                <span
                  className={`font-semibold text-secondary-text text-subtitle-2 flex items-center h-[48px] px-3 bg-white ${index % 2 === 0 ? "border border-blue-100" : "border border-green-100"}`}
                >
                  {item?.title ?? ""}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Industry;
